import {useEffect, useState} from 'react';
import type {ProductCatalogItem, StockMatrix} from '@ozon-ai/ozon/contracts';
import {api} from '../../../api/client';
import {addCalendarDays, businessToday} from '@ozon-ai/periods';

export function useStocksPage() {
	const [to, setTo] = useState(() => businessToday());
	const [from, setFrom] = useState(() => addCalendarDays(businessToday(), -30));
	const [matrix, setMatrix] = useState<StockMatrix | null>(null);
	const [nameByOfferId, setNameByOfferId] = useState<Map<string, string> | null>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		let cancelled = false;
		void api
			.get<ProductCatalogItem[]>('/products/catalog')
			.then((items) => {
				if (cancelled) return;
				setNameByOfferId(new Map(items.map((item) => [item.offerId, item.name])));
			})
			.catch(() => {
				if (!cancelled) setNameByOfferId(new Map());
			});
		return () => {
			cancelled = true;
		};
	}, []);

	useEffect(() => {
		if (!from || !to || from > to) {
			setMatrix(null);
			setError('Дата «С» не может быть позже даты «По»');
			setLoading(false);
			return;
		}

		let cancelled = false;
		setLoading(true);
		setError(null);
		void api
			.post<StockMatrix>('/stocks/matrix', {from, to})
			.then((next) => {
				if (!cancelled) setMatrix(next);
			})
			.catch((err: unknown) => {
				if (!cancelled) {
					setMatrix(null);
					setError(err instanceof Error ? err.message : 'Не удалось загрузить остатки');
				}
			})
			.finally(() => {
				if (!cancelled) setLoading(false);
			});

		return () => {
			cancelled = true;
		};
	}, [from, to]);

	const catalogLoading = nameByOfferId == null;
	const showEmpty =
		!loading && !catalogLoading && !error && matrix != null && matrix.rows.length === 0;
	const showTable =
		!loading && !catalogLoading && !error && matrix != null && matrix.rows.length > 0;

	return {
		from,
		to,
		setFrom,
		setTo,
		matrix,
		nameByOfferId,
		loading: loading || catalogLoading,
		error,
		showEmpty,
		showTable,
	};
}
